// Import necessary modules
import { combineReducers } from 'redux';
import { loginSlice } from '../slices';
import { forgetSlice } from '../slices/forget_password';
import { resendOtpSlice } from '../slices/resend_otp';
import { resetPasswordSlice } from '../slices/reset_password';
import { settingPasswordSlice } from '../slices/setting_password';
import { personalizeSlice } from '../slices/setting_personalization';
import { signupSlice } from '../slices/signup';
import { simulationSlice } from '../slices/simulation';
import { VerifyOneTimePasswordSlice } from '../slices/verify_otp';

import { subscriptionSlice } from '../slices/subscription';
import { scenariosSlice } from '../slices/scenarios';
// import { editEmailSlice } from '../slices/edit-email';

// Combine multiple slices into a single root reducer
export const rootReducer = combineReducers({
  signup: signupSlice.reducer,
  login: loginSlice.reducer,
  VerifyOneTimePassword: VerifyOneTimePasswordSlice.reducer,
  resendOtp: resendOtpSlice.reducer,
  simulation: simulationSlice.reducer,
  forgetPassword: forgetSlice.reducer,
  resetPassword: resetPasswordSlice.reducer,
  personalize: personalizeSlice.reducer,
  settingPassword: settingPasswordSlice.reducer,
  subscription: subscriptionSlice.reducer,
  scenarios: scenariosSlice.reducer
});
